import React, { FC, ReactElement } from 'react';

import { useMediaQuery } from '@material-ui/core';

import classNames from 'classnames';

import styles from './styles.module.scss';

import { ITableTabsProps, ITabItems } from 'types/interfaces';
import { InfoCircle } from 'components/InfoCircle';
import { COALITIONS_TAB, COALITIONS_TAB_DESCRIPTIONS } from '../../../../../../../../../../constants';
import { useAppSelector } from 'store';
import { coalitionsTabTitle } from '../../constants';

export const CoalitionsTabs: FC<ITableTabsProps> = ({
    tableTabs: { title, tabsList },
    className,
    tabSelected,
    handleTabChange,
    withoutData,
    children,
}: ITableTabsProps): ReactElement => {
    const hideDots = useMediaQuery('(max-width:991.98px)');
    const { coalitionType } = useAppSelector(({ organization }) => organization);
    const tabText = withoutData ? 'Coalitions' : coalitionsTabTitle?.[coalitionType];

    return (
        <div className={styles.tabsContainer}>
            <div className={styles.tabsWrapper}>
                {title && (
                    <div
                        className={classNames(styles.mainTitle, {
                            [styles.titleMarginBottom]: !Boolean(tabsList.length),
                        })}
                    >
                        <span>
                            {tabText}
                            {tabsList.length && !hideDots ? ':' : ''}
                        </span>
                    </div>
                )}

                {tabsList.length > 0 && (
                    <div className={classNames(styles.tabsItems, className)}>
                        {tabsList.map((tab: ITabItems) => (
                            <div
                                className={classNames(styles.tab, {
                                    [styles.activeTab]: tabSelected.value === tab.value,
                                })}
                                key={tab.id}
                                onClick={() => handleTabChange(tab)}
                            >
                                <span>{tab.text}</span>
                            </div>
                        ))}
                    </div>
                )}
                <div className={styles.infoIcon}>
                    <InfoCircle tooltipText={COALITIONS_TAB_DESCRIPTIONS[COALITIONS_TAB.COALITIONS]} />
                </div>
            </div>
            {children}
        </div>
    );
};
